var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box light-gray"},[_c('img',{attrs:{"src":"/assets/img/svg/dashboard.svg","alt":""}}),_c('span',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.widget.name)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }